import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
    box: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    radio: {
        width: 18,
        height: 18,
        borderRadius: 9,
        borderWidth: 2,
        borderColor: 'rgba(194, 194, 194, 0.4)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    radioSelected: {
        borderColor: 'red',
    },
    radioDisable: {
        backgroundColor: 'rgba(224, 224, 224, 0.4)',
    },
    radioCheckedIcon: {
        width: 18,
        height: 18,
    },
    labelText: {
        marginLeft: 8,
        color: '#000',
    },
});
